module.exports = __webpack_public_path__ + "media/images/pc/stores/asakusa/asakusa_concept_02-5606e39666c01a596a70220b21b3053c.jpg";